import React from 'react';
import { CoachAvailabilityInterval } from 'globalTypes';
import { findValidTimeSelectOptions, parseMidnightEndTime } from 'coaching/lib/timeIntervals';
import Icon from 'components/Icon';
import Row from 'components/Row';
import Select from 'components/Select';
import Text from 'components/Text';

type Props = {
  interval: CoachAvailabilityInterval;
  index: number;
  onUpdateIntervalStartTime: (newStartTime: string, endTime: string, index: number) => void;
  onUpdateIntervalEndTime: (startTime: string, newEndTime: string, index: number) => void;
  onRemoveInterval: (index: number) => void;
};

export default function TimeInputRow({
  interval,
  index,
  onUpdateIntervalStartTime,
  onUpdateIntervalEndTime,
  onRemoveInterval,
}: Props) {
  const parsedInterval = parseMidnightEndTime(interval);
  const { validStartTimeOptions, validEndTimeOptions } = findValidTimeSelectOptions(parsedInterval);
  return (
    <Row data-test="time-input-row" size="xsmall" key={`${parsedInterval.startTime}-${index}`}>
      <table className="CoachingIsolatedView-timePicker">
        <tbody>
          <tr>
            <td>
              <Select
                data-test={`time-input-row-start-time-${index}`}
                searchable={false}
                inline
                full
                options={validStartTimeOptions}
                value={parsedInterval.startTime}
                onChange={(newStartTime: string) => {
                  onUpdateIntervalStartTime(newStartTime, parsedInterval.endTime, index);
                }}
              />
            </td>
            <td className="CoachingIsolatedView-timePicker-text">
              <Text align="center" element="div">
                to
              </Text>
            </td>
            <td>
              <Select
                data-test={`time-input-row-end-time-${index}`}
                searchable={false}
                inline
                full
                options={validEndTimeOptions}
                value={parsedInterval.endTime}
                onChange={(newEndTime: string) => {
                  onUpdateIntervalEndTime(parsedInterval.startTime, newEndTime, index);
                }}
              />
            </td>
            <td
              className="CoachingIsolatedView-timePicker-close"
              onClick={() => {
                onRemoveInterval(index);
              }}
              data-test="remove-interval-button">
              <Text align="right" element="div">
                <Icon name="x" size="small" color="chalkboard" altText="Remove hours" />
              </Text>
            </td>
          </tr>
        </tbody>
      </table>
    </Row>
  );
}
